import 'uni-pages';import '@dcloudio/uni-stat';

import Vue from 'vue'            
import Page from './pages/scenicTutorials/detail.vue'
createPage(Page)